// Turns the per-day opening hours into the lines the public website shows.
const pretty = (t) => {
  const [h, m] = String(t || "").split(":");
  const hour = Number(h);
  if (Number.isNaN(hour)) return "";
  const suffix = hour < 12 ? "AM" : "PM";
  return `${hour % 12 || 12}:${m} ${suffix}`;
};

const label = (row) =>
  row.closed
    ? "closed"
    : row.ranges.map((r) => `${pretty(r.open)}–${pretty(r.close)}`).join(" & ");

export const hoursLines = (days) => {
  const rows = (days || []).filter((d) => d && d.day);
  if (!rows.length) return [];
  const lines = [];
  let run = [];
  const flush = () => {
    if (!run.length) return;
    const span =
      run.length === 1
        ? run[0].day
        : `${run[0].day}–${run[run.length - 1].day}`;
    lines.push(run[0].closed ? `${span} Closed` : `${span} ${label(run[0])}`);
  };
  rows.forEach((row) => {
    if (run.length && label(row) === label(run[0])) {
      run.push(row);
      return;
    }
    flush();
    run = [row];
  });
  flush();
  return lines;
};
